module.exports = __webpack_public_path__ + "img/task68.4d88d5b7.png";